export default class AlEmailTemplateEditorPreviewModalController {
    constructor($uibModalInstance, $scope, $injector, guestlistId, template) {
        this.uibModalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');
        this.fileSaver = this.injector.get('FileSaver');

        this.template = template;
        this.scopedGuestlists = [];
        this.previewMode = 'contact';
        if (guestlistId) {
            this.scopedGuestlists.push(guestlistId);
            this.previewMode = 'rsvp';
        }
        this.currentSelectedRsvp = null;
        this.currentSelectedContact = null;
        this.rsvp = null;
        this.guestlist = null;
        this.contact = null;

        this.previewLoading = true;
        this.previewData = {};
        this.previewAttachments = [];
        this.previewSize = 'desktop';

        this.extendedMessageParameters = [];
        this.extendedMessageParameterModels = {
            attach_files: true,
            attach_ticket: true,
            attach_passbook: true
        }

        this.send_preview_to_address = _.get(this.injector.get('Users').state, 'loggedin.profile.email', '');
    }

    $onInit() {
        this.scope.$watch(
            () => this.extendedMessageParameterModels,
            () => {
                this._updatePreviewAttachments();
            },
            true
        );
    }

    _prepareExtendedMessageParameters() {
        this.extendedMessageParameters = [];

        if (
            this.template
            && (
                this.template.attachment_1
                || this.template.attachment_2
                || this.template.attachment_3
            )
        ) {
            this.extendedMessageParameters.push({
                key: 'attach_files',
                label: 'Attach Files:',
                default: true
            });
        }

        if (this.previewMode === 'rsvp') {
            if (this.guestlist.ticket_template_id) {
                this.extendedMessageParameters.push({
                    key: 'attach_ticket',
                    label: 'Attach Ticket:'
                });
            }

            if (this.guestlist.passbook_id) {
                this.extendedMessageParameters.push({
                    key: 'attach_passbook',
                    label: 'Attach Wallet:'
                });
            }
        }
    }

    _updatePreview() {
        this.previewData = null;
        this.previewLoadError = false;

        const url = `templates/${this.template.id}/preview/${this.previewMode === 'rsvp' ? 'rsvp' : 'contact'}/${this.previewMode === 'rsvp' ? this.currentSelectedRsvp : this.currentSelectedContact}`;

        if (!url) {
            return;
        }

        this.previewLoading = true;

        this.api.get(url)
            .then(({data}) => {
                this.previewData = data.data;
                // this._updatePreviewAttachments();
                this.previewLoading = false;
            })
            .catch((e) => {
                this.previewLoadError = true;
                this.previewLoading = false;
            })
    }

    changePreviewSize(newSize) {
        this.previewSize = newSize;
    }

    handleRsvpSelected(rsvpId) {
        if (rsvpId) {
            this.currentSelectedRsvp = rsvpId;
            this.rsvp = null;
            this.guestlist = null;
            this.injector.get('$q')
                .all([
                    this._loadRsvpInformation(),
                    this._updatePreview()
                ])
                .then(() => {
                    this._updatePreviewAttachments();
                })
        } else {
            this.rsvp = null;
            this.guestlist = null;
            this.currentSelectedRsvp = null;
        }
    }

    handleContactSelected(contactId) {
        if (contactId) {
            this.currentSelectedContact = contactId;
            this.rsvp = null;
            this.guestlist = null;
            this.injector.get('$q')
                .all([
                    this._loadContactInformation(),
                    this._updatePreview()
                ])
                .then(() => {
                    this._updatePreviewAttachments();
                })
        } else {
            this.rsvp = null;
            this.guestlist = null;
            this.currentSelectedRsvp = null;
        }
    }

    close() {
        this.uibModalInstance.close();
    }

    dismiss() {
        this.uibModalInstance.dismiss();
    }

    _loadRsvpInformation() {
        return this.api
            .get(`rsvps/${this.currentSelectedRsvp}?include=contact,guestlist`)
            .then(({data}) => {
                this.rsvp = data.data;
                this.contact = _.get(data.data, 'contact.data', null);
                this.guestlist = _.get(data.data, 'guestlist.data', null);
                this._prepareExtendedMessageParameters();
            })
    }

    _loadContactInformation() {
        return this.api
            .get(`contacts/${this.currentSelectedContact}`)
            .then(({data}) => {
                this.contact = data.data;
                this._prepareExtendedMessageParameters();
            })
    }

    _updatePreviewAttachments() {
        this.previewAttachments = [];

        if (this.extendedMessageParameterModels.attach_files) {
            for (let i = 1; i < 4; i++) {
                const currentAttachment = this.template[`attachment_${i}`];
                if (currentAttachment) {
                    this.previewAttachments.push({
                        name: currentAttachment.name,
                        action: () => {
                            this.api
                                .get(currentAttachment.url, {responseType: "blob"})
                                .then(({data, headers}) => {
                                    const blob = new Blob([data], {type: headers('content-type')});

                                    this.fileSaver.saveAs(blob, currentAttachment.name);
                                })
                                .catch(err => this.alert.handle(err));
                        }
                    })
                }
            }
        }

        if (!this.previewData) {
            return;
        }

        if (
            this.extendedMessageParameterModels.attach_passbook
            && this.previewData.passbook
        ) {
            const passbook = this.previewData.passbook;

            this.previewAttachments.push({
                name: passbook.passbook_label,
                action: () => {
                    this.api
                        .post(
                            `passbooks/${passbook.passbook_id}/download`,
                            {
                                id: this.guestlist,
                                rsvp_id: this.currentSelectedRsvp,
                                type: 'rsvp'
                            },
                            {responseType: "blob"}
                        )
                        .then(({data, headers}) => {
                            this.fileSaver.saveAs(
                                new Blob([data], {type: headers('content-type')}),
                                passbook.passbook_label
                            );
                        })
                }
            });
        }

        if (
            this.extendedMessageParameterModels.attach_ticket
            && this.previewData.tickets
        ) {
            _.each(this.previewData.tickets, (ticketInformation) => {
                this.previewAttachments.push({
                    name: ticketInformation.file.name,
                    action: () => {
                        this.api
                            .get(
                                ticketInformation.file.url,
                                {responseType: "blob"}
                            )
                            .then(({data, headers}) => {
                                this.fileSaver.saveAs(
                                    new Blob([data], {type: headers('content-type')}),
                                    ticketInformation.file.name
                                );
                            })
                    }
                });
            });
        }
    }

    sendPreviewToBooking() {
        this._sendPreview(_.get(this.rsvp, `contact.data.preferred_email`));
    }

    sendPreviewToGivenAddress() {
        this._sendPreview(this.send_preview_to_address);
    }

    _sendPreview(email) {
        const previewPostData = {
            ...this.extendedMessageParameterModels,
            type: 'email',
            send_to_override: email,
            templates: {
                filters: [
                    {
                        field: 'id',
                        operator: '=',
                        value: this.template.id
                    }
                ],
                count: 1
            },
            recipient_type: this.previewMode
        };

        previewPostData[this.previewMode === 'rsvp' ? 'rsvps' : 'contacts'] = {
            filters: [
                {
                    field: 'id',
                    operator: 'IN',
                    value: [this.previewMode === 'rsvp' ? this.currentSelectedRsvp : this.currentSelectedContact]
                }
            ],
            count: 1
        };
        this.api
            .post(`messages`, previewPostData)
            .then(() => this.alert.success('Success', 'Preview was sent'))
            .catch(() => this.alert.error('Failed', 'Sending preview failed'));
    }
}

AlEmailTemplateEditorPreviewModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector',
    'guestlistId',
    'template'
]



// WEBPACK FOOTER //
// ./src/app/modules/templates/controllers/modals/preview-modal-controller.js